var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisitorPrimary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-650.672 -375.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5434",
    "data-name": "Group 5434",
    transform: "translate(650.563 375.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M11.191,14.9c-2.4,0-7.094,1.186-7.094,3.925v1.585a.755.755,0,0,0,.755.755H17.53a.755.755,0,0,0,.755-.755V18.821c0-2.739-4.7-3.925-7.094-3.925m5.585,4.755H5.606v-.83c0-1.333,3.379-2.415,5.584-2.415s5.585,1.082,5.585,2.415Zm-5.585-5.59A4.335,4.335,0,1,0,6.856,9.725a4.34,4.34,0,0,0,4.334,4.335m0-7.16A2.825,2.825,0,1,1,8.366,9.725,2.828,2.828,0,0,1,11.191,6.9m3.66-1.452a4.335,4.335,0,1,1,0,8.554,5.617,5.617,0,0,0,0-8.554m7.77,13.372v1.585a.755.755,0,0,1-.755.755H19.341a1.95,1.95,0,0,0,.152-.755V18.821c0-1.809-1.269-3.047-2.88-3.856,2.5.284,6.008,1.488,6.008,3.856",
    transform: "translate(-1.005 -1.27)",
    fill: "#334a7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1024",
    "data-name": "Rectangle 1024",
    width: 24,
    height: 24,
    transform: "translate(0.109)",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitorPrimary);
export default __webpack_public_path__ + "static/media/visitor-primary.a7f964485ee4958f31bbfb402f8b1334.svg";
export { ForwardRef as ReactComponent };